const SESSION = "session-";
export const USED_BLOCKS = "usedBlocks";
export const sessionTitleBuilder = (sessionId) => {
    return SESSION + sessionId;
};
export const sessionUsedBlocksTitleBuilder = (sessionId, blockName) => {
    return SESSION + sessionId + "/" + USED_BLOCKS + "/" + blockName;
};
